export const LOGIN_TOKEN = 'LOGIN_TOKEN'
export const NL_TOKEN = 'NL_TOKEN'
